export default "__VITE_ASSET__pMvgzFl___"